import axios from "axios";
import { useQuery } from "react-query";
import { getHeader } from "../utils/util";
import { API_ENDPOINT } from "../utils/constants";

const useLanguages = () => {
  return useQuery({
    queryKey: ["languages-list"],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}/api/languages-list`,
        getHeader()
      );
      return response.data;
    },
    retry: 1,
  });
};

export default useLanguages;
